import type { SkillBuilderConfiguration } from "~skillBuilder/utils/types";

import {
  AzMrtAbuse,
  AzMrtFeedback,
  AzMrtLegal,
  AzMrtOverview,
  AzMrtReporting,
  AzMrtSkillCheck,
  AzMrtSubstitute,
} from "./azMrt";
import {
  CEAttention,
  CEBrainBreaks,
  CEClosing,
  CEExitTickets,
  CEFeedback,
  CEGradeLevels,
  CEOverview,
  CERapport,
  CESkillCheck,
  CEWarmup,
} from "./classroomEngagement";
import {
  CmBestPractices,
  CmCommonPitfalls,
  CmDealingWithDisruptions,
  CmFeedback,
  CmOverview,
  CmSkillCheck,
  CmStartingStrong,
} from "./classroomManagement";
import {
  LWCBeProactive,
  LWCFeedback,
  LWCFirstImpression,
  LWCLastImpression,
  LWCOverview,
  LWCPositiveEnvironment,
  LWCSkillCheck,
  LWCWhatIf,
} from "./leadWithConfidence";
import {
  PAdaptability,
  PBeyondClass,
  PConduct,
  PExpectations,
  PFeedback,
  POverview,
  PReflection,
  PSchool,
  PSkillCheck,
} from "./professionalism";
import {
  RChallenges,
  RCountOnTask,
  RFeedback,
  ROverview,
  RReliableTask,
  RSkillCheck,
  RSupport,
} from "./reliability";
import {
  SECChallenges,
  SECCommunication,
  SECFeedback,
  SECFlexibility,
  SECOverview,
  SECSkillCheck,
  SECStrategies,
  SECTerminology,
} from "./specialEducationClassrooms";
import {
  TspFeedback,
  TspOverview,
  TspProfessionalism,
  TspReliability,
  TspResponsiveClassroomManagement,
  TspSkillCheck,
  TspStudentCenteredInstruction,
  TspStudentEngagement,
  TspSwingExperience,
} from "./theSubPlaybook";

export const SwingConfiguration: SkillBuilderConfiguration = {
  version: "swing",
  groups: [
    // Group #1
    {
      name: "Classroom Management",
      tasks: [
        // Task #1
        CmOverview,
        // Task #2
        CmStartingStrong,
        // Task #3
        CmBestPractices,
        // Task #4
        CmDealingWithDisruptions,
        // Task #5
        CmCommonPitfalls,
        // Task #6
        CmSkillCheck,
      ],
      feedback: CmFeedback,
    },
    // Group #2
    {
      name: "Reliability",
      tasks: [
        // Task #1
        ROverview,
        // Task #2
        RCountOnTask,
        // Task #3
        RReliableTask,
        // Task #4
        RChallenges,
        // Task #5
        RSupport,
        // Task #6
        RSkillCheck,
      ],
      feedback: RFeedback,
    },
    // Group #3
    {
      name: "Lead with Confidence",
      tasks: [
        // Task #1
        LWCOverview,
        // Task #2
        LWCFirstImpression,
        // Task #3
        LWCBeProactive,
        // Task #4
        LWCPositiveEnvironment,
        // Task #5
        LWCWhatIf,
        // Task #6
        LWCLastImpression,
        // Task #7
        LWCSkillCheck,
      ],
      feedback: LWCFeedback,
    },
    // Group #4
    {
      name: "Special Education Classrooms",
      tasks: [
        // Task #1
        SECOverview,
        // Task #2
        SECTerminology,
        // Task #3
        SECCommunication,
        // Task #4
        SECFlexibility,
        // Task #5
        SECStrategies,
        // Task #6
        SECChallenges,
        // Task #7
        SECSkillCheck,
      ],
      feedback: SECFeedback,
    },
    // Group #5
    {
      name: "Classroom Engagement",
      tasks: [
        // Task #1
        CEOverview,
        // Task #2
        CEAttention,
        // Task #3
        CERapport,
        // Task #4
        CEWarmup,
        // Task #5
        CEGradeLevels,
        // Task #6
        CEBrainBreaks,
        // Task #7
        CEExitTickets,
        // Task #8
        CEClosing,
        // Task #9
        CESkillCheck,
      ],
      feedback: CEFeedback,
    },
    // Group #6
    {
      name: "Professionalism",
      tasks: [
        // Task #1
        POverview,
        // Task #2
        PSchool,
        // Task #3
        PExpectations,
        // Task #4
        PConduct,
        // Task #5
        PAdaptability,
        // Task #6
        PBeyondClass,
        // Task #7
        PReflection,
        // Task #8
        PSkillCheck,
      ],
      feedback: PFeedback,
    },
    // Group #7
    {
      name: "Arizona Mandated Reporter Training (AZ Subs Only)",
      tasks: [
        // Task #1
        AzMrtOverview,
        // Task #2
        AzMrtLegal,
        // Task #3
        AzMrtAbuse,
        // Task #4
        AzMrtReporting,
        // Task #5
        AzMrtSubstitute,
        // Task #6
        AzMrtSkillCheck as any,
      ],
      feedback: AzMrtFeedback as any,
    },
    // Group #8
    {
      name: "The Sub Playbook",
      tasks: [
        // Task #1
        TspOverview,
        // Task #2
        TspSwingExperience,
        // Task #3
        TspReliability,
        // Task #4
        TspProfessionalism,
        // Task #5
        TspStudentEngagement,
        // Task #6
        TspResponsiveClassroomManagement,
        // Task #7
        TspStudentCenteredInstruction,
        // Task #8
        TspSkillCheck,
      ],
      feedback: TspFeedback,
    },
  ],
};
